import { Headquarter } from '@elio/emanager-front/offer/model';
import { RoleType } from '@elio/emanager-front/shared/models';
import { Civility, Person } from '@elio/shared/models';
import { Permission } from './auth.model';

export interface User extends Person {
  id: number;
  accountId: number;
  civility: Civility;
  photoId: string;
  phone1: string;
  phone2: string;
  email: string;
  hasMailNotification: boolean;
  offerIds: number[];
  roles: RoleType[];
  permissions: Permission[];
  isProfileDisplayed: boolean;
  isSuperAdmin: boolean;
  headquarters: Headquarter[];
  professionalConfigByOffer: Record<number, ProfessionalConfig>;
}

export interface ProfessionalConfig {
  offerId: number;
  function?: string;
}
